

import React from 'react';
import logo from './logo.svg';
import './App.css';
import AppLayout from './components/AppLayout'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ConfigProvider, theme } from 'antd';

import Home from './pages/Home';
import Chat from './pages/Chat';
import Discover from './pages/Discover';
import Survey from './pages/Survey';
import ExpertSettings from './pages/ExpertSettings';
import CreateExpert from './pages/CreateExpert';
import SignIn from './pages/SignIn';
import NotAuthorized from './pages/NotAuthorized';
import AdminChatHistory from './components/AdminChatHistory';



function App() {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: "#032539",
          colorBgContainer: "#FbF3F2",
          colorBgLayout: "#FbF3F2",
          colorBgElevated: "#FbF3F2",
          colorText: "#032539",
          colorTextSecondary: "#1C768F",
          colorTextTertiary: "#1C768F",
          colorBorder: "#1C768F",
          colorBorderSecondary: "#1C768F",
          colorSuccess: "#FA991C",
          colorWarning: "#FA991C",
          colorError: "#FA991C",
          colorInfo: "#1C768F",
          colorLink: "#032539",
          colorLinkHover: "#1C768F",
          colorLinkActive: "#FA991C",
          borderRadius: 8,
          borderRadiusLG: 12,
          borderRadiusSM: 6,
          fontSize: 14,
          fontSizeLG: 16,
          fontSizeSM: 12,
          lineHeight: 1.5,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
        }
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AppLayout/>}>
            <Route index element={<Discover/>} />
            <Route path="create/" element={<CreateExpert/>} />
            <Route path="signin/" element={<SignIn/>} />
            <Route path="unauthorized/" element={<NotAuthorized/>} />
            <Route path="chat/:expert" element={<Chat/>} />
            <Route path="settings/" element={<ExpertSettings/>} />
            <Route path="survey" element={<Survey/>} />
            <Route path="admin/chats" element={<AdminChatHistory/>} />
            <Route path="*" element={<div>404 Not Found</div>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
